// @flow

export function getWindowSize(): { width: number; height: number } {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

export function getMraidWindowSize(): { width: number; height: number } {
  if (window.mraid) {
    const size = window.mraid.getScreenSize();
    if (size.width !== 0 && size.height !== 0) {
      return size;
    }
  }
  return getWindowSize();
}
